/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Section_PricingInputs */

const cs_property_section_pricing = /** @type {(inputs: Property_Section_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena`)
};

const en_property_section_pricing = /** @type {(inputs: Property_Section_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Property_Section_PricingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_section_pricing = /** @type {((inputs?: Property_Section_PricingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Section_PricingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_section_pricing(inputs)
	return cs_property_section_pricing(inputs)
});